/*                                                   */
import type { NexusSignal } from "@otto-ec/global-resources/nexus";
import type { CamelCase } from "type-fest";
import type { Events } from "../SheetV1.types.js";
import type { EventType } from "./event.index.js";

export const PREFIX = "oc-sheet";

/**
 *
 */
export type NexusEventsMap = {
  [P in keyof Events]: Events[P] extends CustomEvent<infer U> ? NexusSignal<U> : never;
};

export type GetEventPayload<E extends EventAnyDefintion> =
  Events[E[1]] extends CustomEvent<infer U>
    ? U extends Partial<{ instance: HTMLOcSheetV1Element | null | undefined }>
      ? U
      : never
    : never;

export type EventAnyDefintion = EventDefintion<EventType>;

type ExtractApiName<T extends EventType> = T extends `${typeof PREFIX}-${infer N}`
  ? CamelCase<N>
  : never;

/**
 *
 *
 */
export type EventDefintion<T extends EventType> = readonly [
  nexusEvent: ExtractApiName<T>,
  domEvent: T,
  legacyOpenClose: [nexus?: string | undefined, dom?: string | undefined][],
  legacyContentChange: [nexus?: string | undefined, dom?: string | undefined][],
];
